import { Link } from 'react-router-dom';
import type { MediaItem } from '@/types/media';
import { MEDIA_TYPE_LABEL } from '@/types/media';

interface MediaCardProps {
  item: MediaItem;
  className?: string;
}

export default function MediaCard({ item, className = '' }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className={`group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title} - 蘑菇视频影视海报`}
          title={`${item.title} 在线观看与影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-600/90 text-background-50 text-xs font-bold whitespace-nowrap">
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-secondary-950/70 text-background-50 text-[11px] whitespace-nowrap">
          {MEDIA_TYPE_LABEL[item.type]}
        </span>
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/85 via-secondary-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="inline-flex items-center gap-1.5 text-background-50 text-sm font-medium">
            <i className="ri-play-circle-fill text-xl text-primary-400"></i>
            查看详情
          </span>
        </div>
      </div>
      <div className="p-3 flex flex-col gap-1.5">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 truncate">
          {item.cast.slice(0, 2).join(' / ')}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="truncate max-w-[60%] text-right">{item.genres.slice(0, 2).join(' · ')}</span>
        </div>
      </div>
    </Link>
  );
}